import React from 'react';
import { X, AlertCircle, CheckCircle } from 'lucide-react';
import { problemsData } from '../../data/mock';

const ProblemsSection = () => {
  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-stone-100 text-stone-700 text-sm font-medium rounded-full mb-4">
            Desafios
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-4">
            {problemsData.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Problems List */}
          <div className="space-y-4">
            {problemsData.problems.map((problem, index) => (
              <div
                key={index}
                className="flex items-start gap-4 bg-white p-5 rounded-xl border border-stone-200 hover:border-amber-200 hover:shadow-md transition-all duration-300"
              >
                <div className="flex-shrink-0 w-8 h-8 bg-stone-100 rounded-lg flex items-center justify-center">
                  <X className="w-4 h-4 text-stone-500" />
                </div>
                <p className="text-slate-700 leading-relaxed">{problem}</p>
              </div>
            ))}
          </div>

          {/* Value Box */}
          <div className="lg:sticky lg:top-24 h-fit">
            <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-8 text-white shadow-2xl">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-amber-500/20 rounded-xl flex items-center justify-center">
                  <AlertCircle className="w-6 h-6 text-amber-400" />
                </div>
                <h3 className="text-xl font-bold">{problemsData.costBox.title}</h3>
              </div>

              <div className="space-y-4 mb-8">
                {problemsData.costBox.items.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between py-3 border-b border-slate-700/50 last:border-0"
                  >
                    <div className="flex items-center gap-3">
                      <CheckCircle className="w-4 h-4 text-amber-400" />
                      <span className="text-slate-300">{item.label}</span>
                    </div>
                    <span className="font-semibold text-white text-sm">{item.value}</span>
                  </div>
                ))}
              </div>

              <div className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-4">
                <p className="text-amber-300 text-sm mb-1">Investimento em diagnóstico:</p>
                <p className="text-xl font-bold text-white">
                  R$ 3.500 a R$ 12.000
                </p>
              </div>

              <p className="mt-6 text-center text-slate-400 text-sm">
                A preparação adequada é o primeiro passo para vencer licitações.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemsSection;
